import { ComponentStyleConfig } from "@chakra-ui/react";

import { TextVariants } from "../variants";

const { xs, xsSemi, sm, smSemi, md, mdSemi, lg, lgSemi, xl, xlSemi } = TextVariants;

export const Text: ComponentStyleConfig = {
  variants: {
    [xs]: {
      fontSize: "xs",
      fontWeight: "normal",
      lineHeight: "md",
    },
    [xsSemi]: {
      fontSize: "xs",
      fontWeight: "semibold",
      lineHeight: "md",
    },
    [sm]: {
      fontSize: "sm",
      fontWeight: "normal",
      lineHeight: "lg",
    },
    [smSemi]: {
      fontSize: "sm",
      fontWeight: "semibold",
      lineHeight: "xl",
    },
    [md]: {
      fontSize: "md",
      fontWeight: "normal",
      lineHeight: "lg",
    },
    [mdSemi]: {
      fontSize: "md",
      fontWeight: "semibold",
      lineHeight: "xl",
    },
    [lg]: {
      fontSize: "lg",
      fontWeight: "normal",
      lineHeight: "xl",
    },
    [lgSemi]: {
      fontSize: "lg",
      fontWeight: "semibold",
      lineHeight: "xl",
    },
    [xl]: {
      fontSize: "xl",
      fontWeight: "normal",
      lineHeight: "lg",
    },
    [xlSemi]: {
      fontSize: "xl",
      fontWeight: "semibold",
      lineHeight: "lg",
    },
  },
  defaultProps: {
    variant: md,
  },
};
